export default __webpack_public_path__ + "static/photoshoot_1-5c56e06656dab767b5fd8fd9cf799954.png";